<template>
	<event-assignments-list :url="`/v1/views/clubs/${clubStore.club.id}/competition-planner`"
							ref="listComponent"
							   :filter="filterData" searchable
							   :details-path-resolver="event => `/clubs/${clubStore.club._key}/events/${event._key}/participations`"
							   :missing-text="t('missing.club.participations.planned', {name: clubStore.club.display_name})">

		<template #default>
			<client-only>
				<template v-if="clubStore.hasMemberPermission(ClubPermission.ManageMembers)">
					<container-fab-btn :hide-on-scroll="!$device.isDesktop">
						<btn :title="t('action.add_participation')"
							 color="success"
							 shadow
							 rounded-large
							 @click="showAddParticipationModal = true">
							<icon :icon="icons.create"/>
							<span>{{ t('action.add') }}</span>
						</btn>
					</container-fab-btn>

					<add-manual-participation-modal v-model="showAddParticipationModal"
													disable-upload
													disable-connections
													:title="clubStore.club.display_name"
													:fixed-data="{club_id: clubStore.club.id}"
													:user-select-params="{type: 'member', group_type: ModelType.Club, group_id: clubStore.club.id}"
													@success="handleAddedParticipation"/>
				</template>
			</client-only>
		</template>
	</event-assignments-list>
</template>

<script setup lang="ts">
import {useClubStore} from "../../../store/club";
import {ClubPermission, ModelType} from "@spoferan/spoferan-ts-core";
import {createIcon} from "@spoferan/nuxt-spoferan/icons";

const clubStore = useClubStore();
const {t} = useI18n();
const route = useRoute();

const icons = {
	create: createIcon
};

const filterData = ref({
	search: route.query.search,
});

const listComponent = ref(null);
const showAddParticipationModal = ref(false);

async function handleAddedParticipation() {
	listComponent.value.refresh();
}

useMeta({
	title: clubStore.buildPageTitle(t('view.clubs.competition_planner.index.title', {club: clubStore.club.display_name})),
	description: t('view.clubs.competition_planner.index.description', {club: clubStore.club.display_name}),
})

</script>